import * as React from 'react';
/**
 *
 * Original name: mic
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A357
 *
 */
export const MicPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M32 41c6.99 0 11-4.009 11-11V19c0-6.991-4.01-11-11-11s-11 4.009-11 11v11c0 6.991 4.01 11 11 11Zm-7-22c0-4.776 2.225-7 7-7s7 2.224 7 7v11c0 4.776-2.225 7-7 7s-7-2.224-7-7V19Z", fill: "currentColor" }),
    React.createElement("path", { d: "M52 30h-4c0 10.767-5.233 16-16 16s-16-5.233-16-16h-4c0 12.211 6.376 19.217 18 19.929V56h4v-6.071C45.624 49.217 52 42.211 52 30Z", fill: "currentColor" })));
